<mat-form-field>
    <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
    <input type="text" matInput [formControl]="control" [name]="name" [title]="title" [id]="id" [class]="classList && classList.join(' ')" [matAutocomplete]="auto" [errorStateMatcher]="matcher" [debounce]="debounceAfter || 1000" (eventHandler)="updateModelAndEmitDebounceEvent()" (click)="panelOpen = true" />
    <material-button *ngIf="description && description.length > 0" matSuffix buttonType="icon" size="small" [titleText]="description" tabindex="-1" prefixIcon="info" prefixIconType="material"></material-button>
    <mat-hint align="start" *ngIf="lookupHint">
        <strong>
            <span>*</span>
            Master Search
        </strong>
    </mat-hint>
    <mat-hint align="end" *ngIf="maxLength"><span [textContent]="((control.value && control.value.length) || 0) + ' / ' + maxLength"></span></mat-hint>
    <mat-hint align="start" *ngIf="required && !lookupHint && !(errors && errors.length > 0)">
        <strong>
            <span>*</span>
            Required
        </strong>
    </mat-hint>
    <mat-error *ngIf="control.hasError('errors')" [textContent]="errors"></mat-error>
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete" class="matAutocompleteOptionsContainer" (optionSelected)="selectedOption($event)">
    <div *ngIf="hasSearch" class="autoCompleteSearch px-2">
        <material-input [placeholder]="'Search...'" [model]="searchOptions" [debounceAfter]="1000" (modelChange)="searchOptions = $event" (debounceEventHandler)="searchChanged.emit(searchOptions)"></material-input>
    </div>
    <mat-option *ngFor="let option of options" [value]="option.value" [ngClass]="{ matOptionHide: dataPresentation === 'table' }">
        <span [textContent]="option.displayName"></span>
    </mat-option>
    <ng-container *ngIf="dataPresentation === 'table'">
        <material-table [allTableColumns]="allColumns" [selectedColumns]="selectedColumns" [data]="tableData" (onDoubleClickEvent)="onRecordSelect($event)" (recordSelectedEvent)="onRecordSelect($event)"></material-table>
    </ng-container>
    <div *ngIf="!masterDisabled && options && options.length === 0" class="noOptionsFound">No options found</div>
</mat-autocomplete>
